<template lang="pug">
  .columns.is-vcentered.is-mobile
    template(v-if="type === 'code'")
      .container.has-text-centered.column.p0
        h1 Digite o código de ativação da empresa
        p.is-size-6.mb30 Caso seja funcionário e não possua acesso ao sistema,
          |  entre em contato com o responsável de sua empresa.
        div.columns.is-centered
          .column.is-one-third
            InputText(v-focus="", type="tel", v-model="activateCode", autocomplete="off",
            @keyup.enter="registerWithCode", pattern=".{3,}", required="true", focus="" id="activatecode")
            .has-text-centered
              Button3d(@click="registerWithCode", color="primary", size="large", :block="true" id="confirmaactivatecode") Entrar
        p.is-size-6
          | Você também pode fazer o cadastro da máquina via
          a.has-link.is-size-6(@click="switchType('email')")   login pontotel

    template(v-if="type === 'email'")
      .container.has-text-centered.column.p0
        h1 Faça autenticação de seu usuário
        p Caso seja funcionário e não possua acesso ao sistema,
          |  entre em contato com o responsável de sua empresa.

        br
        .columns.is-centered
          .column.is-one-third
            template(v-if="stepEmailType === 'email'")
              InputText(v-focus="", type="text", placeholder='E-mail', v-model="email", @keyup.enter="checkEmail",
              autocomplete="on", pattern=".{3,}", required="true", key="email")

              .has-text-centered(key="prox")
                Button3d(@click="checkEmail", color="primary", size="large", :block="true") Próximo >

            template(v-else="")
              InputText(type="password", placeholder="Senha", v-model="password", @keyup.enter="registerWithLogin",
              autocomplete="off", pattern=".{3,}", required="true", key="pass")

              .has-text-centered(key="sign")
                Button3d(@click="registerWithLogin", color="primary", size="large", :block="true") Entrar
        p
          | Você também pode fazer o cadastro da máquina via
          a.has-link(@click="switchType('code')")   código de ativação.

</template>

<script>
export default {
  props: {
    type: {
      'default': 'email',
      type: String,
      validator: function (value) {
        return ['email', 'code'].includes(value)
      }
    },
    userId: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      stepEmailType: 'email',

    }
  },
  computed: {
    activateCode: {
      get () {
        return this.$store.state.register.activateCode
      },
      set (value) {
        this.$store.commit('register/activateCode', value)
      }
    },
    email: {
      get () {
        return this.$store.state.register.email
      },
      set (value) {
        this.$store.commit('register/email', value)
      }
    },
    password: {
      get () {
        return this.$store.state.register.password
      },
      set (value) {
        this.$store.commit('register/password', value)
      }
    }
  },
  methods: {
    switchType (type) {
      this.$router.push({name: 'register', params: {type}})
    },
    registerWithLogin () {
      this.$store.dispatch('register/registerWithLogin')
    },
    registerWithCode () {
      this.$store.dispatch('register/registerWithCode')
    },
    async checkEmail () {
      try {
        const result = await this.$API.getAuthUserPool.save({email: this.email})

        const { userPoolWebClientId, userPoolId, webSamlURL, useCognito } = result.data.success
        this.stepEmailType = 'password'

        if (useCognito) {
          if (webSamlURL) {
            // Back said to redirect to this page cuz this user should use cognito
            window.location.href = webSamlURL
          }

          this.$store.commit('cognitoInfo', {userPoolId, userPoolWebClientId, useCognito})
        }
      } catch (e) {
        this.stepEmailType = 'password'
        // actualy the API has break, it dont mean that user dont exists, its just better
        // to say this error instead of an error happened
        // this.$swal({type:' info', title: 'Usuário não encontrado', text: 'Esse usuário não foi encontrado no sistema'})
      }
    }
  }
}
</script>
